import { ErpHealthInsuranceValue } from '../../shared/model/travelmanagement-values';

export class A1Bescheinigung {

    socialInsuranceNumber?: string;
    healthInsuranceSelected?: ErpHealthInsuranceValue;
    destinationDetails?: string;
    destinationsOfTheLastYears?: string;
}
